import React from 'react';

export type DefaultMessageProps = {
  message: string;
  header?: string;
  actionBtnText?: string;
  callback?: () => void;
};

const DefaultMessage = ({
  header = '',
  message,
  actionBtnText = 'OK'
}: DefaultMessageProps) => (
  <div className="flex justify-between items-center">
    <div className="mr-8">
      {header && <h3 className="font-bold">{header}</h3>}
      <p className="text-xs">{message}</p>
    </div>
    <span className="border px-4 py-2 rounded-sm">{actionBtnText}</span>
  </div>
);

export default DefaultMessage;
